/** Raid display depth layers.
 * telegraph < aoeFx < units < boss < chrome/fx/float.
 * Ground/area skill VFX stay under the boss silhouette; hit particles/floats stay above.
 */
export const RaidDepth = {
  ground: 1,
  /** Subtle darken outside playBounds (above plate, below gesture). */
  playMask: 1.25,
  /** Gesture aim/area rings (above ground, below telegraph). */
  gesture: 1.6,
  telegraph: 2,
  /** Slam/brass/leap area impacts & cast cues (under bodies). */
  aoeFx: 6,
  unitIdle: 10,
  unitActive: 14,
  boss: 18,
  /** Boss primary-aggro arrow (above bodies, under HP chrome). */
  aggroArrow: 20,
  unitChrome: 22,
  /** Pin ring above HP chrome. */
  gesturePin: 23,
  fx: 26,
  float: 32,
  hud: 40,
} as const;

export const RAID_BODY_Y_BAND = 3;

export function raidBodyDepth(
  base: typeof RaidDepth.unitIdle | typeof RaidDepth.unitActive,
  y: number,
  mapH: number,
): number {
  const h = Math.max(1, mapH);
  const yNorm = Math.max(0, Math.min(1, y / h));
  return base + yNorm * RAID_BODY_Y_BAND;
}

/** Boss depth: above unit bodies, still y-sorted slightly within boss band. */
export function raidBossDepth(y: number, mapH: number): number {
  const h = Math.max(1, mapH);
  const yNorm = Math.max(0, Math.min(1, y / h));
  return RaidDepth.boss + yNorm * RAID_BODY_Y_BAND;
}
